export default "__VITE_ASSET__1caf3060__"